import React, { useState, useEffect } from "react";
import Cookies from "js-cookie";
import moment from "moment";
import Pagination from "../Common/Pagination/Pagination";
import { toast } from "react-toastify";
import PrivateOrderDispatch from "./DispatchDetails/PrivateOrderDispatch";
import GovtOrderDispatch from "./DispatchDetails/GovtOrderDispatch";
import TKCSOrderDispatch from "./DispatchDetails/TKCSOrderDispatch";
import DispatchDetails from "./DispatchDetails/DispatchDetails";

const DispatchDetailsStatus = ({ selectedDate, companyDetails }) => {
  const SERVER_URL = process.env.REACT_APP_SERVER_URL;
  const user_id = Cookies.get("users_id")?.replace(/"/g, "");
  const token = Cookies.get("token")?.replace(/"/g, "");

  const [showDispatch, setShowDispatch] = useState(true);
  const [showGovt, setShowGovt] = useState(false);
  const [showPrivate, setShowPrivate] = useState(false);
  const [showTKCS, setShowTKCS] = useState(false);

  useEffect(() => {
    const storedTab = Cookies.get("dispatchSelectedTab");
    if (storedTab) {
      const parsedTab = JSON.parse(storedTab);
      setShowDispatch(parsedTab.showDispatch);
      setShowGovt(parsedTab.showGovt);
      setShowPrivate(parsedTab.showPrivate);
      setShowTKCS(parsedTab.showTKCS);
    }
  }, []);
  const handleSwitchTabs = (tab) => {
    if (tab === "dispatch") {
      setShowDispatch(true);
      setShowGovt(false);
      setShowPrivate(false);
      setShowTKCS(false);
    } else if (tab === "govt") {
      setShowDispatch(false);
      setShowGovt(true);
      setShowPrivate(false);
      setShowTKCS(false);
    } else if (tab === "private") {
      setShowDispatch(false);
      setShowGovt(false);
      setShowPrivate(true);
      setShowTKCS(false);
    } else if (tab === "tkcs") {
      setShowDispatch(false);
      setShowGovt(false);
      setShowPrivate(false);
      setShowTKCS(true);
    }
    Cookies.set(
      "dispatchSelectedTab",
      JSON.stringify({
        showDispatch: tab === "dispatch" ? true : false,
        showPrivate: tab === "private" ? true : false,
        showTKCS: tab === "tkcs" ? true : false,
        showGovt: tab === "govt" ? true : false,
      })
    );
  };

  return (
    <>
      <div className="row">
        <div className="col-md-12 grid-margin stretch-card">
          <div className="card">
            <div className="card-body dashboard-tabs p-0">
              <ul
                className="nav nav-tabs px-4 border-left-0 border-top-0 border-right-0"
                role="tablist"
              >
                <li
                  className="nav-item"
                  onClick={() => handleSwitchTabs("dispatch")}
                >
                  <a
                    className={`nav-link ${showDispatch ? "active" : ""}`}
                    id="govt-tab"
                    data-toggle="tab"
                    href="#govt"
                    role="tab"
                    aria-controls="private"
                    aria-selected="true"
                  >
                    All Dispatch Details Status
                  </a>
                </li>
                <li
                  className="nav-item"
                  onClick={() => handleSwitchTabs("govt")}
                >
                  <a
                    className={`nav-link ${showGovt ? "active" : ""}`}
                    id="private-tab"
                    data-toggle="tab"
                    href="#private"
                    role="tab"
                    aria-controls="tkcs"
                    aria-selected="false"
                  >
                    Govt Dispatch Status
                  </a>
                </li>
                <li
                  className="nav-item"
                  onClick={() => handleSwitchTabs("private")}
                >
                  <a
                    className={`nav-link ${showPrivate ? "active" : ""}`}
                    id="private-tab"
                    data-toggle="tab"
                    href="#private"
                    role="tab"
                    aria-controls="tkcs"
                    aria-selected="false"
                  >
                    Private Dispatch Status
                  </a>
                </li>
                <li
                  className="nav-item"
                  onClick={() => handleSwitchTabs("tkcs")}
                >
                  <a
                    className={`nav-link ${showTKCS ? "active" : ""}`}
                    id="tkcs-tab"
                    data-toggle="tab"
                    href="#tkcs"
                    role="tab"
                    aria-controls="tkcs"
                    aria-selected="false"
                  >
                    TKCS Dispatch Status
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      {showDispatch && (
        <div data-aos="fade-in">
          <DispatchDetails
            selectedDate={selectedDate}
            companyDetails={companyDetails}
          />
        </div>
      )}
      {showTKCS && (
        <div data-aos="fade-in">
          <TKCSOrderDispatch
            selectedDate={selectedDate}
            companyDetails={companyDetails}
          />
        </div>
      )}
      {showGovt && (
        <div data-aos="fade-in">
          <GovtOrderDispatch
            selectedDate={selectedDate}
            companyDetails={companyDetails}
          />
        </div>
      )}
      {showPrivate && (
        <div data-aos="fade-in">
          {" "}
          <PrivateOrderDispatch
            selectedDate={selectedDate}
            companyDetails={companyDetails}
          />
        </div>
      )}
    </>
  );
};

export default DispatchDetailsStatus;
